import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

interface PageShellProps {
  children: ReactNode;
  overlayHeader?: boolean;
}

export default function PageShell({ children, overlayHeader = false }: PageShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader overlay={overlayHeader} />
      <main className={`flex-1 ${overlayHeader ? "" : "pt-[72px]"}`}>{children}</main>
      <SiteFooter />
    </div>
  );
}